import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './Legal.css';

function CookiePolicy() {
  const navigate = useNavigate();
  return (
    <div className="legal-page">
      <nav className="legal-nav">
        <div className="logo" onClick={() => navigate('/')}>
          <img src="/JobLinkedAI.png" alt="JobLinked AI" />
          JobLinked AI
        </div>
        <button className="legal-back-btn" onClick={() => navigate(-1)}>
          <i className="fas fa-arrow-left"></i> Back
        </button>
      </nav>

      <div className="legal-hero">
        <h1>Cookie Policy</h1>
        <p>How we use cookies and similar technologies</p>
      </div>

      <div className="legal-content">
        <span className="legal-effective">Effective Date: 18 April 2025</span>

        <div className="legal-section">
          <h2>1. What Are Cookies?</h2>
          <p>Cookies are small text files stored on your device when you visit a website. They help the website remember your preferences, keep you logged in, and understand how you use the site.</p>
          <p>We also use similar technologies such as localStorage and sessionStorage in your browser to store session tokens and user preferences.</p>
        </div>

        <div className="legal-section">
          <h2>2. Cookies We Use</h2>
          <h3>2.1 Strictly Necessary</h3>
          <p>These are essential for the Platform to function. Without them, you cannot log in or use core features.</p>
          <ul>
            <li><strong>auth_token</strong> — Stores your authentication token to keep you logged in (localStorage)</li>
            <li><strong>user_type</strong> — Remembers whether you are a job seeker or recruiter (localStorage)</li>
            <li><strong>user_name</strong> — Stores your display name for the dashboard greeting (localStorage)</li>
          </ul>

          <h3>2.2 Functional</h3>
          <p>These improve your experience by remembering your preferences.</p>
          <ul>
            <li><strong>theme</strong> — Remembers your dark/light mode preference (localStorage)</li>
          </ul>

          <h3>2.3 Analytics (Future)</h3>
          <p>We may in future use analytics cookies to understand how users interact with the Platform. We will update this policy and request consent before doing so.</p>

          <h3>2.4 Third-Party Cookies</h3>
          <p>When you make a payment via Paystack, Paystack may set their own cookies on their hosted payment page. We do not control these cookies. Please refer to <a href="https://paystack.com/privacy" target="_blank" rel="noreferrer" style={{color:'#60a5fa'}}>Paystack's Privacy Policy</a> for details.</p>
        </div>

        <div className="legal-section">
          <h2>3. How Long Do Cookies Last?</h2>
          <ul>
            <li>Session data (auth tokens) — cleared when you log out or the token expires (30 minutes by default)</li>
            <li>Preference data (theme) — persists until you clear your browser storage or change the setting</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>4. Managing Cookies</h2>
          <p>You can control and delete cookies through your browser settings. Note that disabling strictly necessary cookies will prevent you from logging in and using the Platform.</p>
          <p>To clear localStorage data in your browser:</p>
          <ul>
            <li>Chrome / Edge: DevTools → Application → Local Storage → Clear</li>
            <li>Firefox: DevTools → Storage → Local Storage → Clear</li>
            <li>Safari: Preferences → Privacy → Manage Website Data</li>
          </ul>
          <p>Logging out of the Platform automatically clears your authentication data.</p>
        </div>

        <div className="legal-section">
          <h2>5. Your Consent</h2>
          <p>By using JobLinked AI, you consent to our use of strictly necessary cookies and localStorage as described in this policy. These are required for the Platform to function and cannot be opted out of while using the service.</p>
          <p>For any non-essential cookies we introduce in future, we will request your explicit consent.</p>
        </div>

        <div className="legal-section">
          <h2>6. Changes to This Policy</h2>
          <p>We may update this Cookie Policy as we add new features or technologies. The effective date at the top of this page will reflect the latest version.</p>
        </div>

        <div className="legal-contact-box">
          <p>Questions about our use of cookies? Contact us at <a href="mailto:privacy@joblinked.ai">privacy@joblinked.ai</a></p>
        </div>
      </div>

      <footer className="legal-footer">
        <p>&copy; 2025 JobLinked AI. All rights reserved. Built with ❤️ in South Africa</p>
        <p style={{ marginTop: '0.5rem' }}>
          <Link to="/terms">Terms &amp; Conditions</Link>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/cookies">Cookie Policy</Link>
        </p>
      </footer>
    </div>
  );
}

export default CookiePolicy;
